import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ModuleList from './ModuleList';
import ModuleListService from '../services/ModuleListService';

class ModuleListContainer extends Component {
  static propTypes = {
    courseId: PropTypes.string.isRequired,
  };

  moduleListService = new ModuleListService(this.props.courseId);
  componentDidMount() {
    this.moduleListService.load();
  }

  render() {
    return (
      <ModuleList
        modules={toJS(this.moduleListService.modules)}
        fetching={this.moduleListService.fetch.fetching}
        onDelete={this.moduleListService.handleRemove}
        onPublish={this.moduleListService.handlePublish}
        onUnpublish={this.moduleListService.handleUnpublish}
      />
    );
  }
}

export default observer(ModuleListContainer);
